import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MUISelect,
} from '@mui/material';
import React from 'react';
import { IProps } from './contract';

export const Select = ({
  fullWidth = false,
  labelId,
  label,
  value,
  onChange,
  options,
  variant = 'outlined',
}: IProps) => {
  return (
    <FormControl fullWidth={fullWidth} variant={variant}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <MUISelect
        fullWidth={fullWidth}
        labelId={labelId}
        label={label}
        value={value}
        onChange={(e) => onChange((e.target.value as typeof value))}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MUISelect>
    </FormControl>
  );
};
